import {
  REOPEN_CONVERSATION_GET,
  REOPEN_CONVERSATION_POST,
  REOPEN_CONVERSATION_RES,
} from "./actionTypes";

export const reopenConversationGet = (id) => ({
  type: REOPEN_CONVERSATION_GET,
  payload: { id },
});

export const reopenConversationPost = (id, data) => ({
  type: REOPEN_CONVERSATION_POST,
  payload: { id, data },
});

export const reopenConversationRes = (data, action) => ({
  type: REOPEN_CONVERSATION_RES,
  payload: { data, action },
});
